module.exports = "<app-response-instructions-view-details [config]=\"config\"></app-response-instructions-view-details>\r\n"